<div class="year-currency-wrapper" [class.align-end]="alignEnd" [class.align-start]="!alignEnd">
    <ng-content></ng-content>
    <span *ngIf="yearLabel" class="year-label">{{ yearLabel }}</span>
    <div *ngIf="showCurrency" class="currency-label">
        <ng-container *ngIf="!isEditing">
            <span class="currency-edit-icon ham-icon" (click)="startEditing($event)">
                <i class="edit-icon"></i>
            </span>
            <span class="currency-text">{{ currency }}</span>
        </ng-container>
        <span
            *ngIf="isEditing"
            class="currency-check-icon ham-icon"
            (mousedown)="$event.preventDefault()"
            (click)="save(currentEditingValue)"
        >
            <i class="check-icon"></i>
        </span>
        <input
            *ngIf="isEditing"
            class="currency-input"
            type="text"
            [value]="currency"
            (input)="currentEditingValue = $any($event.target).value"
            (blur)="onBlur($event)"
            (keydown.enter)="onEnter($event)"
            (keydown.escape)="onEscape()"
            stopPropagation
            autofocus
        />
    </div>
</div>
